import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import { notifyPromise } from "../../../Utils/Helper";
import { momumpayPaymentSuccess, momumpayPaymentFailure } from "../../Action";
import { MONUMPAY_DEPOSIT } from "../../Action/actionTypes";

function* monumpayRequest(action) {
    try {
        const { data } = yield notifyPromise(
            API.post("/monumpay-deposit", action?.payload?.monumpayPayload)
        );
        if (action?.payload?.callback) {
            yield call(action.payload.callback, data);
        }
        if (data?.meta?.code === 200) {
            yield put(momumpayPaymentSuccess(data?.data));

        } else {
            yield put(momumpayPaymentFailure());
        }
    } catch (error) {
        yield put(momumpayPaymentFailure());
    }
}

export function* watchMonumpayAPI() {
    yield takeEvery(MONUMPAY_DEPOSIT, monumpayRequest);
}

export default function* rootSaga() {
    yield all([watchMonumpayAPI()]);
}
